import { render, staticRenderFns } from "./DraggableCategories.vue?vue&type=template&id=34ac7d9e&scoped=true&"
import script from "./DraggableCategories.vue?vue&type=script&lang=js&"
export * from "./DraggableCategories.vue?vue&type=script&lang=js&"
import style0 from "./DraggableCategories.vue?vue&type=style&index=0&id=34ac7d9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ac7d9e",
  null
  
)

export default component.exports